import request from 'api/request';
import {handleError} from 'helpers';

import * as alerts from 'actions/alertActions';
import {devAccessActionTypes} from './actionTypes';

export const loadDeveloperAccess = () => dispatch => {
  dispatch({type: devAccessActionTypes.DEV_ACCESS_LOADING});

  return request({url: `/Auth`})
    .then(response =>
      dispatch({
        type: devAccessActionTypes.DEV_ACCESS_COMPLETE,
        data:
          response && response.data
            ? {
                apiKey: response.data.clientName,
                apiSecret: response.data.secret,
              }
            : {},
      }),
    )
    .catch(error => {
      dispatch({type: devAccessActionTypes.DEV_ACCESS_FAIL});
      handleError('Unable to load plan details', error, dispatch);
    });
};

export const getAPIKey = () => dispatch => {
  dispatch({type: devAccessActionTypes.GET_API_KEY_LOADING});

  return request({url: '/Auth', method: 'POST'})
    .then(response => {
      if (!response || response.status === 500 || !response.data) {
        throw new Error('Unable to get API key');
      }

      dispatch({
        type: devAccessActionTypes.GET_API_KEY_COMPLETE,
        data: {
          apiKey: response.data.clientName,
          apiSecret: response.data.secret,
        },
      });
    })
    .catch(error => {
      dispatch({
        type: devAccessActionTypes.GET_API_KEY_COMPLETE,
        data: {},
      });
      handleError('Error getting API Key', error, dispatch);
    });
};

export const getAccessToken = password => dispatch => {
  dispatch({type: devAccessActionTypes.GET_TOKEN_LOADING});

  return request({url: '/Auth/token', method: 'POST', body: {password}})
    .then(response => {
      if (!response || response.status === 500 || !response.data) {
        throw new Error('incorrect password');
      }

      const exp = new Date(Date.now() + response.data.expires_in * 1000);

      dispatch({
        type: devAccessActionTypes.GET_TOKEN_COMPLETE,
        data: {
          accessToken: response.data.access_token,
          tokenExpiration: exp.toString(),
          refreshToken: response.data.refresh_token,
        },
      });
      return true;
    })
    .catch(() => {
      dispatch({
        type: devAccessActionTypes.GET_TOKEN_COMPLETE,
        data: {},
      });
      dispatch(alerts.error('Invalid password'));
    });
};



// WEBPACK FOOTER //
// ./src/actions/devAccessActions.js